import React from "react";
import { Box } from "@mui/material";
import { AttachmentIcon, EmojiIcon, MicIcon } from "../widgetPreviewIcons";
import { COLORS, FONT } from "../../../shared/styles";

function WidgetInputBar({ placeholder = "Type your message ..." }) {
  return (
    <Box
      sx={{
        height: "58px",
        borderTop: "1px solid #F4F5F7",
        display: "flex",
        alignItems: "center",
        px: "16px",
        position: "relative",
        background: COLORS.white,
        borderRadius: "0 0 8px 8px",
      }}
    >
      <Box
        component="input"
        readOnly
        placeholder={placeholder}
        sx={{
          flex: 1,
          border: "none",
          outline: "none",
          background: "transparent",
          fontFamily: FONT.family,
          fontSize: "14px",
          color: COLORS.textSecondary,
          "&::placeholder": { color: "#C5CED6", opacity: 1 },
        }}
      />
      <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <MicIcon />
        <EmojiIcon />
        <AttachmentIcon />
      </Box>
    </Box>
  );
}

export default WidgetInputBar;
